"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeEdgeWeights = void 0;
var react_1 = __importDefault(require("react"));
var Dropdown_1 = require("office-ui-fabric-react/lib/Dropdown");
var constants_1 = require("../../shared/constants");
var WEIGHT_OPTIONS = Object.keys(constants_1.EDGE_WEIGHT_VALUES).map(function (type) { return ({ key: type, text: constants_1.EDGE_WEIGHT_LABELS[type] }); });
/**
 * NodeEdgeWeights - Per-target edge weight pickers shown inside a node row's
 * "Edge Weight" cell. Hides entries pointing to deleted target nodes.
 */
exports.NodeEdgeWeights = function (_a) {
    var edges = _a.edges, nextLayerNodes = _a.nextLayerNodes, onChangeWeight = _a.onChangeWeight;
    var entries = Object.entries(edges);
    if (entries.length === 0) {
        return react_1.default.createElement("span", { className: "ws-no-connections" }, "No connections");
    }
    return (react_1.default.createElement("div", { className: "ws-connection-weights" }, entries.map(function (_a) {
        var targetId = _a[0], weight = _a[1];
        var targetNode = nextLayerNodes.find(function (n) { return n.id === targetId; });
        if (!targetNode)
            return null;
        var currentWeightType = constants_1.parseEdgeWeight(weight);
        return (react_1.default.createElement("div", { key: targetId, className: "ws-connection-weight-item" },
            react_1.default.createElement("div", { className: "ws-connection-weight-dropdown" },
                react_1.default.createElement(Dropdown_1.Dropdown, { options: WEIGHT_OPTIONS, selectedKey: currentWeightType, onChange: function (_, option) {
                        if (option) {
                            onChangeWeight(targetId, option.key);
                        }
                    } })),
            react_1.default.createElement("div", { className: "ws-connection-weight-name" }, targetNode.name)));
    })));
};
